export class MissingUscTcVersionError extends Error {
  constructor(oppId: string, countryCode: string) {
    super(
      `[TermsAndConditions] oppId: ${oppId} countryCode: ${countryCode} does not have uscTcVersion while USC flow is enabled`,
    );
  }
}
